import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import LiquidEther from 'LiquidEther';

const HeroSection = () => {
  return (
    <section className="w-full min-h-screen relative bg-gradient-to-br from-deep-space via-slate-900 to-slate-800 overflow-hidden flex items-center justify-center px-4 sm:px-6 lg:px-12">
      
      {/* Background animation */}
      <div className="absolute inset-0 pointer-events-none">
        <LiquidEther
          colors={['#5227FF', '#FF9FFC', '#B19EEF']}
          mouseForce={20}
          cursorSize={100}
          isViscous={false}
          viscous={30}
          iterationsViscous={32}
          iterationsPoisson={32}
          resolution={0.5}
          isBounce={false}
          autoDemo={true}
          autoSpeed={0.5}
          autoIntensity={2.2}
          takeoverDuration={0.25}
          autoResumeDelay={3000}
          autoRampDuration={0.6}
        />
      </div>

      {/* Main content */}
      <div className="relative w-full max-w-7xl mx-auto py-12 sm:py-16 lg:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          
          {/* Left content */}
          <div className="text-center lg:text-left px-2 sm:px-0">
            <div className="mb-6">
              <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2 mb-4">
                <div className="w-2 h-2 bg-trust-green rounded-full animate-pulse"></div>
                <span className="text-white text-sm font-medium">Available for Opportunities</span>
              </div>

              <h1 className="text-3xl sm:text-4xl lg:text-6xl font-headline text-white mb-6 leading-tight">
                I Am <br />
                <span className="text-transparent bg-gradient-to-r from-rocket-fire to-electric-cyan bg-clip-text">
                  Lokendra Kumar.
                </span>
              </h1>

              <p className="text-base sm:text-lg lg:text-xl text-slate-300 mb-8 max-w-2xl mx-auto lg:mx-0 leading-relaxed">
                A MERN stack developer skilled in building seamless user experiences from front to back. My focus is on creating scalable and efficient applications, with a knack for problem-solving and clean code architecture.
              </p>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <a href="#ProjectHanger">
                <Button
                  variant="default"
                  size="lg"
                  className="bg-rocket-fire hover:bg-rocket-fire/90 text-white font-cta shadow-brand-lg w-full sm:w-auto"
                  iconName="Lightbulb"
                  iconPosition="right"
                >
                  Project Hanger
                </Button>
              </a>

              <a href="#SkillsAndTech">
                <Button
                  variant="default"
                  size="lg"
                  className="bg-rocket-fire hover:bg-rocket-fire/90 text-white font-cta shadow-brand-lg w-full sm:w-auto"
                  iconName="Code"
                  iconPosition="right"
                >
                  Skills And Technologies
                </Button>
              </a>

              <a href="https://drive.google.com/file/d/1Z6dDJOKy3zWfDfeohi6FU9feCnjSGTFM/view?usp=sharing">
                <Button
                  variant="outline"
                  size="lg"
                  className="border-white/30 text-white hover:bg-white/10 backdrop-blur-sm w-full sm:w-auto"
                  iconName="Download"
                  iconPosition="left"
                >
                  Download Resume
                </Button>
              </a>
            </div>

            {/* Quick Stats */}
            <div className="flex flex-wrap gap-6 justify-center lg:justify-start mt-10">
              <div className="text-center">
                <div className="text-xl sm:text-2xl font-bold text-white">15+</div>
                <div className="text-sm text-slate-400">Projects Completed</div>
              </div>
              <div className="text-center">
                <div className="text-xl sm:text-2xl font-bold text-white">150+</div>
                <div className="text-sm text-slate-400">Questions on LeetCode</div>
              </div>
              <div className="text-center">
                <div className="text-xl sm:text-2xl font-bold text-white">100+</div>
                <div className="text-sm text-slate-400">Active Days On LeetCode</div>
              </div>
            </div>
          </div>

          {/* Right content */}
          <div className="relative">
            <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10">
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center space-x-2">
                  <div className="w-3 h-3 bg-trust-green rounded-full"></div>
                  <span className="text-white text-sm font-medium">Mission Control Active</span>
                </div>
                <div className="text-slate-400 text-sm">{new Date().toLocaleDateString()}</div>
              </div>

              <div className="space-y-3 mb-6">
                {["Frontend Systems", "Backend Services", "Database Connection"].map((sys) => (
                  <div key={sys} className="flex items-center justify-between">
                    <span className="text-slate-300">{sys}</span>
                    <div className="flex items-center space-x-2">
                      <div className="w-2 h-2 bg-trust-green rounded-full"></div>
                      <span className="text-trust-green text-sm">Operational</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Floating icons */}
            <div className="absolute -top-4 -right-4 w-8 h-8 bg-rocket-fire rounded-full flex items-center justify-center animate-bounce">
              <Icon name="Rocket" size={16} color="white" />
            </div>
            <div className="absolute -bottom-4 -left-4 w-6 h-6 bg-electric-cyan rounded-full flex items-center justify-center animate-pulse">
              <Icon name="Zap" size={12} color="white" />
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <a href="#ProjectHanger">
          <div className="flex flex-col items-center space-y-2">
            <span className="text-white/60 text-sm">Explore More</span>
            <Icon name="ChevronDown" size={20} color="white" className="opacity-60" />
          </div>
        </a>
      </div>
    </section>
  );
};

export default HeroSection;
